module.exports = __webpack_public_path__ + "static/media/Health-Record-Form.6393e81f.pdf";